"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMGTHighchartsOptionsProvider = exports.getProjectsParticipantsChartTitle = void 0;
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const ProjectDashboardHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectDashboardHighchartsOptionsProvider");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const getProjectsParticipantsChartTitle = (lineType) => {
    switch (lineType) {
        case LineTypeJSONModel_1.LineType.cumulative:
            return "Usergeek MGT Users Cumulative";
        default:
            return "Usergeek MGT Users";
    }
};
exports.getProjectsParticipantsChartTitle = getProjectsParticipantsChartTitle;
const computeLastNOptions = (numbers) => {
    const numberOfDays = numbers.length;
    const testIntervalStartTimeSec = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDayEndOf().subtract(numberOfDays - 1, "day").valueOf() / 1000;
    return {
        data: Int32Array.from(numbers),
        intervalStartTimeSec: testIntervalStartTimeSec
    };
};
const getNewUsers = (data, parameters, chartStatus) => {
    // console.log("AdminMGTHighchartsOptionsProvider.getNewUsers:", data, parameters);
    if (data) {
        const state = computeLastNOptions(data);
        const result = ProjectDashboardHighchartsOptionsProvider_1.ProjectDashboardHighchartsOptionsProvider.optionsForChartLastNIntervalData(state, { chartTitle: (0, exports.getProjectsParticipantsChartTitle)(parameters) }, chartStatus);
        return result;
    }
    return {
        options: {},
        chartStatus: chartStatus
    };
};
const getDAU = (allClientsDAU, parameters, chartStatus) => {
    // console.log("AdminMGTHighchartsOptionsProvider.getDAU:", data, parameters);
    if (allClientsDAU != undefined) {
        const state = computeLastNOptions(allClientsDAU);
        const result = ProjectDashboardHighchartsOptionsProvider_1.ProjectDashboardHighchartsOptionsProvider.optionsForChartLastNIntervalData(state, parameters, chartStatus);
        return result;
    }
    return {
        options: {},
        chartStatus: chartStatus
    };
};
exports.AdminMGTHighchartsOptionsProvider = {
    getDAU,
    getNewUsers
};
